import React, { FunctionComponent } from 'react';
import { format } from 'date-fns';
import { Symbol, Skeleton, ICON_STAR } from '@doveit/bricks';
import * as styles from './ReviewCard.style';

export const ReviewCardSkeleton: FunctionComponent = () => (
  <article
    css={styles.base}
  >
    <header css={styles.header}>
      <Skeleton count={2} />
    </header>
    <div css={styles.review}>
      <Skeleton height="10rem" />
    </div>
    <footer css={styles.footer}>
      <div css={styles.stars}>
        <Skeleton width="10rem" />
      </div>
    </footer>
  </article>
);

export interface ReviewCardProps {
  author: string,
  date: string,
  rating: number,
  review: string,
}

const ReviewCard: FunctionComponent<ReviewCardProps> = ({
  author,
  date,
  rating,
  review,
}) => (
  <article
    css={styles.base}
  >
    <header css={styles.header}>
      <div>
        {author}
      </div>
      <time>
        {format(new Date(date), 'dd/MM/yyyy')}
      </time>
    </header>
    <div css={styles.review}>
      {review}
    </div>
    <footer css={styles.footer}>
      <div css={styles.stars}>
        {[1, 2, 3, 4, 5].map((index) => (
          <div
            key={index}
            css={styles.star}
            full={index <= rating}
          >
            <Symbol
              path={ICON_STAR}
              size={28}
            />
          </div>
        ))}
      </div>
    </footer>
  </article>
);

export default ReviewCard;
